import { render } from "./typeTable.vue?vue&type=template&id=e39ff502"
import script from "./typeTable.vue?vue&type=script&lang=js"
export * from "./typeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__